import React from "react";
import { FaEdit, FaArrowUp, FaArrowDown } from "react-icons/fa";
import "./mybookings.css";
import AuthService from "../services/AuthServices";
import { toast } from "react-toastify";
import DateFormatter from "./Formatter/DateFormatter";
import { handleLogout } from "../utils/logout";
function MyBookingsDesign({ mybooking, allTypes,categories,employeeAll }) {
  const [selectedBook, setSelectedBook] = React.useState(0);
  const [isEditing, setIsEditing] = React.useState(false);
  const [token, setToken] = React.useState();
  const [editedBooking, setEditedBooking] = React.useState(null); 
  const [visibleCount, setVisibleCount] = React.useState(6); 
  const [isExpanded, setIsExpanded] = React.useState(false); 
  const [employee, setEmployee] = React.useState([]);
  const [userId, setUserId] = React.useState("");
  const [allBraids, setAllBraids] = React.useState([]);
  const calculateEndTimeWithHours = (startTime, durationInHours) => {
    const [startHours, startMinutes] = startTime.split(":").map(Number);

    const startDate = new Date();
    startDate.setHours(startHours);
    startDate.setMinutes(startMinutes);
 
    const endDate = new Date(startDate.getTime() + parseFloat(durationInHours) * 60 * 60 * 1000);
  
  
    // Formater l'heure de fin
    const endHours = String(endDate.getHours()).padStart(2, "0");
    const endMinutes = String(endDate.getMinutes()).padStart(2, "0");
  
  
    return `${endHours}:${endMinutes}`; // Retourner l'heure de fin formatée
  };
  
  const BASE_URL2 = "https://ginasafricanhairbraiding.terangapp.com/api/users";


  const bookPress = (index) => {
    setSelectedBook(index);
  };
  const editPress = (booking) => {
    setEditedBooking({ ...booking }); 
    setIsEditing(true); 
  };

  const cancelEdit = () => {
    setIsEditing(false); 
    setEditedBooking(null); 
  };

  const getUserData = () => {
    const tok = localStorage.getItem("token");
    const id = localStorage.getItem("id");
    if (!tok) {
      handleLogout();
    }
    setToken(tok);
    setUserId(id);
  };

  React.useEffect(() => {
    getUserData();
  }, []);

  // Sort bookings by date (most recent first)
  const sortedBookings = [...mybooking].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const handleUpdateBooking = async () => {
    try {
      const response = await AuthService.updateOrder(
        token,
        editedBooking.id,
        editedBooking
      );
      if (response.message) {
        toast.success(response.message);
        setIsEditing(false); // Close the edit form after success
        setEditedBooking(null); // Clear the edited booking data
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      toast.error("Failed to update order");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startTime') {
      const selectedBraid = allBraids.find(braid => braid.id === parseInt(editedBooking.braid_id));
      if (selectedBraid) {
        const newEndTime = calculateEndTimeWithHours(value, selectedBraid.time);
        setEditedBooking(prevState => ({
          ...prevState,
          [name]: value,
          price: selectedBraid.priceNormal, 
          time: selectedBraid.time,
          endTime: newEndTime,
        }));
      }
      else {
        toast.error('Please select a braid');
      }
    }
    else {
      const selectedBraid = allBraids.find(braid => braid.id === parseInt(editedBooking.braid_id));
      if (selectedBraid) {
        const newEndTime = calculateEndTimeWithHours(editedBooking.startTime, selectedBraid.time);
        setEditedBooking(prevState => ({
          ...prevState,
          [name]: value,
          price: selectedBraid.priceNormal, 
          time: selectedBraid.time,
          endTime: newEndTime,       
        }));

    } 
    else {
      toast.error('Please select a braid');
    }
    }
   
  };
  

  const handleToggleExpand = () => {
    if (isExpanded) {
      setVisibleCount(6);
    } else {
      setVisibleCount(sortedBookings.length);
    }
    setIsExpanded(!isExpanded);
  };
;
const handleBraids = React.useCallback(() => {
  const fetchData = async (fetchFunction, successCallback, errorMessage) => {
    try {
      if (token && userId) {
        const response = await fetchFunction(userId, token);
        if (response.data) {
          successCallback(response.data);
        } else {
          toast.error(response.error);
        }
      }
    } catch (error) {
      toast.error(errorMessage);
    }
  };

  fetchData(AuthService.getAllBraids, setAllBraids, "Error fetching braids");
}, [token, userId]);



React.useEffect(()=>
{
  if (token) handleBraids();
  }, [token,handleBraids]);


  // Fetch Employees only when editing
  React.useEffect(() => {
    const fetchAvailableEmployees = async () => {
      if (
        editedBooking &&
        editedBooking.date &&
        editedBooking.startTime &&
        editedBooking.endTime
      ) {
        const fetchUrl = `${BASE_URL2}/availableEmployees/${editedBooking.date}/${editedBooking.startTime}/${editedBooking.endTime}`;

        try {
          const response = await fetch(fetchUrl, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(
              errorResponse.message || "Failed to fetch employees."
            );
          }

          const availableEmployees = await response.json();
          const enrichedEmployees = availableEmployees.map((emp) => {
            const fullEmployee = employeeAll.find(
              (e) => e.firstName === emp.firstName && e.lastName === emp.lastName
            );
  
            return fullEmployee ? {
              ...emp,
              id: fullEmployee.id 
            } : emp;
          });
  
          setEmployee(enrichedEmployees);
        } catch (error) {
          toast.error(error.message || "Failed to load employees.");
        }
      }
    };
    fetchAvailableEmployees();
  }, [editedBooking, token,employeeAll]);
 

  return (
    <>
      <div className="my-bookings">
        <div className="bookings-container">
          {sortedBookings.slice(0, visibleCount).map((booking, index) => (
            <div
              className={`booking-card ${
                selectedBook === index ? "selected" : ""
              }`}
              key={index}
              onClick={() => bookPress(index)}
            >
              <h2>{booking.braid_name}</h2>
              <p>
                <strong>Date:</strong> { DateFormatter({date:booking.date})  }
              </p>
              <p>
                <strong>Time:</strong> {booking.startTime} - {booking.endTime}
              </p>
              <p>
                <strong>Price($):</strong> {booking.price}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span
                  className={`status ${booking.order_status.toLowerCase()}`}
                >
                  {booking.order_status}
                </span>
              </p>
              <p>
                <strong>Place:</strong> {booking.place_name}
              </p>
              <p>
                <strong>Tresseur:</strong> {booking.employee_name}
              </p>

              {selectedBook === index && (
                <div className="actions">
                  {booking.order_status === "pending" && (
                    <button
                      className="edit-btn"
                      onClick={() => editPress(booking)}
                    >
                      <FaEdit /> Edit
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* "Voir Plus / Voir Moins" Button */}
        {sortedBookings.length > 5 && (
          <div className="rowM" style={{ paddingTop: "12px" }}>
            <button
              className={isExpanded ? "load-less-btn" : "load-more-btn"}
              onClick={handleToggleExpand}
            >
              <span className={isExpanded ? "see-less-text" : "see-more-text"}>
                {" "}
                {isExpanded ? "View Less" : "View Mor"}
              </span>
              {isExpanded ? (
                <FaArrowUp className="see-less-icon" />
              ) : (
                <FaArrowDown className="see-more-icon" />
              )}
            </button>
          </div>
        )}
      </div>

      {/* Edit form */}
      {isEditing && editedBooking && (
        <div className="edit-modal-overlay">
          <div className="edit-form">
            <h3>Edit Booking</h3>
            <form>
              {/* Braid Name Select */}
              <label>
                Braid Name:
                <select
                  name="braid_id"
                  value={editedBooking.braid_id}
                  onChange={handleInputChange}
                >
                  {allTypes.length > 0 ? (
                    allTypes.map((braid) => {
                      const category = categories.find(
                        (cat) => cat.id === braid.type_categories_id
                      );
                      const categoryName = category
                        ? category.name
                        : "Unknown Category";
                      return (
                        <option key={braid.id} value={braid.id}>
                          {braid.name} ({categoryName})
                        </option>
                      );
                    })
                  ) : (
                    <option disabled >No braid types available</option>
                  )}
                </select>
              </label>
              <label>
                Date:
                <input
                  type="date"
                  name="date"
                  value={DateFormatter({date:editedBooking.date}).replace(/\//g, "-")}
                  onChange={handleInputChange}
                />
              </label>
              {/* Employee Select */}
                <label>
                  Employee:
                  <select
                    name="employer_id"
                    value={editedBooking.employer_id}
                    onChange={handleInputChange}
                  >
                    {employee.map((emp, index) => (
                      <option key={index} value={emp.id}>
                        {emp.firstName} {emp.lastName}
                      </option>
                    ))}
                  </select>
                </label>
              {/* Price Input (readonly) */}
              <label>
                Price ($):
                <input
                  type="number"
                  name="price"
                  value={editedBooking.price}
                  readOnly
                />
              </label>

              {/* Start Time Input */}
              <label>
                Start Time:
                <input
                  type="time"
                  name="startTime"
                  value={editedBooking.startTime}
                  onChange={handleInputChange}
                />
              </label>

              {/* End Time Input (readonly) */}
              <label>
                End Time:
                <input
                  type="time"
                  name="endTime"
                  value={editedBooking.endTime}
                  readOnly
                />
              </label>

              {/* Action Buttons */}
              <div className="form-actions">
                <button type="button" onClick={handleUpdateBooking}>
                  Save
                </button>
                <button type="button" onClick={cancelEdit}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default MyBookingsDesign;
